<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"
        style="enable-background:new 0 0 16 16;" xml:space="preserve" aria-hidden="true">
        <g id="Tornado">
            <path class="st4" d="M14.5,4.8c0.1,0.2,0.1,1.3,0,1.5c-0.5,1.4-1.3,1.8-2.4,3c-0.2,0.2-0.5,0.4-1.3,1c-0.6,0.5-1.8,1.1-2.2,1.7
		c-0.7,1-0.4,1.8-0.1,2.9c0.1,0.4,0.5,0.8,0.1,1c-0.4,0.2-0.8,0.2-1.2,0c-2-1.1-3.2-2.7-3-4.7c-0.6-0.5-1-1.1-0.9-1.8
		c0-0.1,0.1-0.3,0.1-0.4C2.9,8.6,2.3,8.2,2.1,7.5C1.9,6.8,2.2,6.2,2.6,5.7c-0.8-0.8-1.4-1.9-0.9-3c0.8-2.1,4.5-2.6,6.7-2.6
		c1.7,0,3.7,0.3,5.1,1.2C15.2,2.3,15.5,3.7,14.5,4.8L14.5,4.8z M8.5,7.9c0.4,0,0.9-0.1,1.4-0.1c0.2,0,0.3-0.2,0.3-0.4
		c0-0.2-0.2-0.3-0.4-0.3C9.3,7.1,8.8,7.2,8.4,7.2c-0.7,0.1-1.2,0.1-1.7,0C5.6,7.2,5.3,6.9,5.2,6.8C5.1,6.6,4.9,6.6,4.7,6.7
		C4.5,6.8,4.5,7,4.6,7.2c0.3,0.5,1,0.7,2.1,0.8c0.2,0,0.4,0,0.6,0C7.6,8,8,8,8.5,7.9z M7.8,10.7c0.2,0,0.4-0.2,0.3-0.4
		c0-0.2-0.2-0.4-0.4-0.3c-0.4,0-0.7,0-1,0c-0.3,0-0.5-0.1-0.6-0.3C6,9.5,5.8,9.5,5.7,9.7c-0.1,0.1-0.1,0.4,0,0.5
		c0.3,0.3,0.8,0.4,1,0.5c0.2,0,0.4,0.1,0.7,0.1C7.5,10.7,7.7,10.7,7.8,10.7z M8.8,2.9C8.5,2.9,8.3,2.9,8,3C7.8,3,7.4,3.1,7.3,3.3
		C7.3,3.5,7.5,3.7,7.7,3.8c0.9,0.2,2,0.3,3,0.1c0.6-0.1,1.8-0.3,1.9-0.9c0.1-0.7-1.3-1.1-1.9-1.3C9.9,1.6,9.1,1.5,8.4,1.5
		C7.4,1.5,6.2,1.6,5.2,2c-0.4,0.1-1.5,0.5-1.4,1c0,0.5,1.1,0.8,1.6,0.9C6,2.4,7.3,2.1,8.8,2.6C8.9,2.6,9,2.7,9,2.8
		C9,2.8,8.9,2.9,8.8,2.9L8.8,2.9z M12.8,5.6C13,5.5,13.1,5.3,13,5.1c-0.1-0.2-0.3-0.3-0.5-0.2c-0.7,0.4-1.8,0.5-2.9,0.4
		c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.4,0.3,0.4c0.2,0,0.5,0,0.7,0C11.2,6.1,12.2,5.9,12.8,5.6z" />
            <path class="st3"
                d="M9.7,8.1c0.2-0.1,5.9-2.6,5.7-5.8c-0.1-1.5-3.8-2.1-7.1-2.1c-1.4,0-2.7,0.1-3.8,0.3C2.8,0.7,1.9,1.2,1.6,1.9
		C1.4,2.6,1.9,3.5,3,4.5c0.8,0.6,0.5,1-0.3,1.7C2,6.9,1.2,7.7,1.2,9.1c-0.1,2.7,2.4,3.6,4.5,4.3c1.6,0.5,2.9,1,2.8,2L8.5,16L9,15.6
		c0.1-0.1,1.6-1.4,1.3-2.8c-0.2-0.7-0.8-1.3-1.9-1.7c-0.9-0.3-1.4-0.7-1.4-1C7,9.7,7.3,9.1,9.7,8.1z M5.7,10.3
		c0,1.1,1.1,1.5,2.1,1.9c0.7,0.3,1.3,0.5,1.5,0.8c0.2,0.4-0.1,0.8-0.2,1c0.1-1-1.6-1.5-2.8-1.9C4,11.4,2.6,10.5,2.4,9.7
		C2.3,8.8,2.6,7.8,4.4,6.2c0.5-0.4,0.7-0.7,0.7-1c0-0.2-0.1-0.4-0.3-0.6C5.8,4.9,6.9,5,7.9,5c2.1,0,4.4-0.4,5.7-0.9
		c-0.7,1.1-2.8,2.5-4.4,3.1C6,8.4,5.6,9.5,5.7,10.3z M13.9,2.3c0,0.1-0.1,0.2-0.1,0.2l-0.1,0l0,0c-0.8,0.5-2.4,0.8-4.7,0.8l-0.5,0
		C5.1,3.4,3.2,2.8,3,2.3c0-0.1,0-0.1,0-0.1c0.6-0.8,2.3-1.1,5.5-1.1l0.1,0c2.7,0,4.4,0.6,4.8,0.8C13.6,2,13.9,2.2,13.9,2.3z" />
        </g>
    </svg>
</template>

<style scoped>
path {
    fill: white;
}
</style>
